import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { uniqueId } from 'lodash';

export type FeedbackType = 'success' | 'error' | 'alert';

export type Feedback = {
  id: string;
  text: string;
  type: FeedbackType;
};

export type Feedbacks = {
  items: Feedback[];
};

const initialState: Feedbacks = {
  items: [],
};

const feedbacksSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    resetFeedbacks: () => initialState,
    addFeedback: (
      state,
      action: PayloadAction<{ text: string; type: FeedbackType }>,
    ) => {
      const newFeedback: Feedback = {
        id: uniqueId('feedback_'),
        text: action.payload.text,
        type: action.payload.type,
      };
      state.items.push(newFeedback);
    },
    removeFeedback: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
  },
});

export const { resetFeedbacks, addFeedback, removeFeedback } =
  feedbacksSlice.actions;

export default feedbacksSlice.reducer;
